import { ConfigProvider, Tabs } from "antd";
import { useEffect, useState } from "react";
import { CaseInfoType } from "lib/types";
import AlertDetail from "./alertDetail";
import CaseDetail from "./caseDetail";
import { getCaseByAlert } from "../service";
import { motion } from "motion/react";
import { getCaseDetail } from "pages/dashboard/cases/service";
import { showToast } from "ui/components/common";
export default function RightPanel({ alert, onAlertStatusChange, activeCase }) {
  const [activeTab, setActiveTab] = useState("alert");

  useEffect(() => {
    if (!alert) return;
    setActiveTab("alert");
  }, [alert]);
  return (
    <motion.div
      initial={false}
      animate={alert ? "open" : "close"}
      variants={{
        open: {
          width: "475px",
          clipPath: "inset(0% 0% 0% 0% round 10px)",
          transition: {
            type: "spring",
            bounce: 0,
            duration: 0.7,
            delayChildren: 0.3,
            staggerChildren: 0.05,
          },
        },
        close: {
          width: "0px",
          clipPath: "inset(10% 50% 90% 50% round 10px)",
          transition: {
            type: "spring",
            bounce: 0,
            duration: 0.3,
          },
        },
      }}
      style={{
        pointerEvents: "auto",
        position: "relative",
        zIndex: 1,
      }}
    >
      <div
        style={{
          width: "475px",
          height: "100%",
          backgroundColor: "white",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <ConfigProvider
          theme={{
            components: {
              Tabs: {
                inkBarColor: "rgba(62, 131, 246, 1)",
                itemColor: "rgba(34, 34, 34, 1)",
                itemActiveColor: "rgba(62, 131, 246, 1)",
                itemSelectedColor: "rgba(62, 131, 246, 1)",
                itemHoverColor: "rgba(62, 131, 246, 1)",
              },
            },
          }}
        >
          {activeCase ? (
            <Tabs
              style={{ flex: "none" }}
              className="alertTabSelection"
              activeKey={activeTab}
              items={[
                { label: "Alert & Live", key: "alert" },
                { label: "Case & Timeline", key: "case" },
              ]}
              onChange={setActiveTab}
              centered={true}
              size={"large"}
            />
          ) : (
            <Tabs
              style={{ flex: "none" }}
              className="alertTabSelectionSingle"
              activeKey={"alert"}
              items={[{ label: "Alert & Live", key: "alert" }]}
              centered={true}
              size={"large"}
            />
          )}
        </ConfigProvider>
        <div style={{ flex: "1", maxHeight: "calc(100% - 90px)" }}>
          {activeTab === "alert" && alert && (
            <AlertDetail
              alert={alert}
              onAlertStatusChange={() => {
                onAlertStatusChange?.(alert);
              }}
              activeCase={activeCase}
            />
          )}
          {activeTab === "case" && activeCase && (
            <CaseDetail activeCase={activeCase} activeAlert={alert} />
          )}
        </div>
      </div>
    </motion.div>
  );
}
